module.exports = __webpack_public_path__ + "img/mobile_menu_control.c94c2505.svg";